import initApm from "@elastic/apm-rum";

export default function InitApm() {
  try {
    initApm({
      serviceName: process.env.REACT_APP_ELASTIC_APM_SERVICE_NAME || 'morpheus-dev',
      serverUrl: process.env.REACT_APP_ELASTIC_APM_SERVER_URL || 'https://b8f06876136c40d6906f13266d135079.apm.us-central1.gcp.cloud.es.io:443',
      environment: process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT || 'alpha',
    });
  } catch (e: any) {
    console.log("APM ERROR", e.message);
  }
} 
